module.exports = __webpack_public_path__ + "img/coming-soon-1.e841a2bc.svg";